module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1B9htz9/tc-custom/9780830870080.jpg?1696025165669",
      "alt": "This image is the cover for the book Exploring the Old Testament, Exploring the Bible Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Exploring the Old Testament, Exploring the Bible Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('em', [_vm._v("Exploring the Old Testament: A Guide to the Pentateuch")]), _vm._v(" offers a clear overview of the \"five books of Moses,\" as well as an introduction to the historical and textual questions that modern scholarship has posed and the answers it has proposed. This critically informed, textually sensitive introduction to the Pentateuch introduces students to")]), _vm._v("  the basic features of the Pentateuch the social world of the Bible the latest scholarship on the composition of the Pentateuch literary techniques and forms theme, composition and rhetorical function of the Pentateuch  "), _c('p', [_vm._v("In this textbook you will find double-column formatting for ease of use, annotated bibliographies for further reading, sidebar explorations of select historical and textual topics in greater detail, a glossary of terms, and relevant charts and maps.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gordon J. Wenham\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Gordon J. Wenham is lecturer in Old Testament at Trinity College, Bristol. He was formerly professor of Old Testament at the University of Gloucestershire. He is a recognized expert on the Pentateuch and has written commentaries on Genesis, Leviticus and Numbers in addition to numerous studies in the Old Testament.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    InterVarsity Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0